import Default from './default';
import ReactSelect from './react-select';
import Switch from './switch';
import TimePicker from './time-picker';
import ReactDatePicker from './date-picker';
import Search from './search';
import DefaultWithIcon from './with-icon';

const Forms = {
  Default,
  ReactSelect,
  Switch,
  TimePicker,
  ReactDatePicker,
  Search,
  DefaultWithIcon,
};

export default Forms;
